import l from "../../../../../@babel_runtime@7.25.6/node_modules/@babel/runtime/helpers/esm/extends.js";
import r from "vue";
import i from "./Dialog.js";
import { isServer as a } from "../utils/index.js";
var t;
function s(n) {
  return document.body.contains(n);
}
function c() {
  t && t.$destroy(), t = new (r.extend(i))({
    el: document.createElement("div"),
    // avoid missing animation when first rendered
    propsData: {
      lazyRender: !1
    }
  }), t.$on("input", function (n) {
    t.value = n;
  });
}
function e(n) {
  return a ? Promise.resolve() : new Promise(function (o, u) {
    (!t || !s(t.$el)) && c(), l(t, e.currentOptions, n, {
      resolve: o,
      reject: u
    });
  });
}
e.defaultOptions = {
  value: !0,
  title: "",
  width: "",
  theme: null,
  message: "",
  overlay: !0,
  className: "",
  allowHtml: !0,
  lockScroll: !0,
  transition: "van-dialog-bounce",
  beforeClose: null,
  overlayClass: "",
  overlayStyle: null,
  messageAlign: "",
  getContainer: "body",
  cancelButtonText: "",
  cancelButtonColor: null,
  confirmButtonText: "",
  confirmButtonColor: null,
  showConfirmButton: !0,
  showCancelButton: !1,
  closeOnPopstate: !0,
  closeOnClickOverlay: !1,
  callback: function callback(o) {
    t[o === "confirm" ? "resolve" : "reject"](o);
  }
};
e.alert = e;
e.confirm = function (n) {
  return e(l({
    showCancelButton: !0
  }, n));
};
e.close = function () {
  t && (t.value = !1);
};
e.setDefaultOptions = function (n) {
  l(e.currentOptions, n);
};
e.resetDefaultOptions = function () {
  e.currentOptions = l({}, e.defaultOptions);
};
e.resetDefaultOptions();
e.install = function () {
  r.use(i);
};
e.Component = i;
r.prototype.$dialog = e;
export { e as default };
